import React from "react";
import { connect } from "react-redux";
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { SetDepositSuccessPage, SetMethodsActive, GetBounsList } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'

class SuccessPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            copyType: '',
        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {
        // let isGetBound = this.props?.DepositPayments?.bonusResult?.toLocaleUpperCase()?.includes('SUCCESS')
        // const { depositingWallet, bonusId, bonusRuleGroupId } = GetParamsData() || {}
        // let money = this.props.DepositMoneyStatus?.money
        // isGetBound && this.props.GetBounsList({ depositingWallet, bonusId, money, bonusRuleGroupId })
    }
    componentWillUnmount() {

    }


    render() {
        const { LivechatClick, goRecord, bonusName, BackClick, BackMyPromo } = GetParamsData()
        const {
            MethodsActive,
            SetDepositSuccessPage,
            DepositPayments,
            DepositMoneyStatus,
            SuccessPage,
            DepositBouns
        } = this.props;
        const { uniqueAmount } = DepositPayments || {}
        const { money } = DepositMoneyStatus || {}
        const amount = numberWithCommas(uniqueAmount && uniqueAmount != 0 && uniqueAmount || money)
        let { methods } = MethodsActive
        let timeOBj = {
            LB: 1800,
            QD: 1800,
            BQR: 1800,
            LBQR: 600,
            MMO: 600,
            FP: 600,
            ZLP: 600,
            PHC: 600,
            VP: 600, // FP5-1920
            CC: 900,
            CTC: 600
        }
        let times = timeOBj[methods] || 600
        return (
            <>
                <SuccessPage
                    times={times}
                    bonusName={bonusName}
                    BackClick={BackClick}
                    BackMyPromo={BackMyPromo}
                    MethodsActive={MethodsActive}
                    DepositPayments={DepositPayments}
                    HistoryClick={(type) => {
                        goRecord(type, methods)
                        SetDepositSuccessPage()
                    }}
                    onChange={() => { 
                        SetDepositSuccessPage()
                        const { paymentMethods = [] } = this.props.Methods || {}
                        this.props.SetMethodsActive(paymentMethods[0])
                    }}
                    backClick={() => { 
                        SetDepositSuccessPage()
                        const { paymentMethods = [] } = this.props.Methods || {}
                        let index = paymentMethods.findIndex(v => v.code == 'LB') || 0 //FP5-1577
                        this.props.SetMethodsActive(paymentMethods[index])
                     }}
                    money={amount}
                    LivechatClick={LivechatClick}
                    DepositBouns={DepositBouns}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    Methods: state.Methods,
    DepositBouns: state.DepositBouns,
    MethodsActive: state.MethodsActive,
    DepositPayments: state.DepositPayments,
    DepositMoneyStatus: state.DepositMoneyStatus,
});
const mapDispatchToProps = {
    SetDepositSuccessPage: (data = false) => SetDepositSuccessPage(data),
    SetMethodsActive: (data = {}) => SetMethodsActive(data),
    GetBounsList: (data = {}) => GetBounsList(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);


